// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings item row */
.NT5C42JZOYzKUzH3LgbA {
  display: flex;
  padding: 9px 5px;
  justify-content: center;
  align-items: center;
  background-color: var(--dark-grey);
  border-radius: 8px;
  min-height: 54px;
  width: 100%;
  max-width: 424px;
  margin: 0 auto 10px;
}
.uSJATcwjNIzOaL59V_qA {
  width: 25px;
  margin-right: 10px;
  flex-shrink: 0;
  /* Prevent icon from collapsing when text grows */
  display: flex;
  align-items: center;
  justify-content: center;
  /* fallow-ignore-next-line unused-export */
}
.uSJATcwjNIzOaL59V_qA .hMMTbANT6O4ETtME3DEA,
.uSJATcwjNIzOaL59V_qA .mJ8VUokWkyUNjufMhUY0 {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.cTjuyFKj6gJz1zAqqSyq {
  min-width: 150px;
  max-width: 500px;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: left;
  padding-right: 3em;
}
.cTjuyFKj6gJz1zAqqSyq .OMzJXYDHXoiIQEcgmAZw {
  font-size: 16.2px;
  font-weight: 700;
  font-style: bold;
}
.cTjuyFKj6gJz1zAqqSyq .Qh40jG59iSQ_gzempUhe {
  font-size: 12.6px;
  font-weight: 400;
  color: var(--settings-modal-text-color);
}
.X4Mj6K5UeIHvXGMcQ0Sx {
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  /* Prevent value/toggle from collapsing */
}
`, "",{"version":3,"sources":["webpack://./src/features/settings/components/SettingsItem/SettingsItem.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C","sourcesContent":["/* Settings item row */\n.settingItem {\n  display: flex;\n  padding: 9px 5px;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--dark-grey);\n  border-radius: 8px;\n  min-height: 54px;\n  width: 100%;\n  max-width: 424px;\n  margin: 0 auto 10px;\n}\n.settingIcon {\n  width: 25px;\n  margin-right: 10px;\n  flex-shrink: 0;\n  /* Prevent icon from collapsing when text grows */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* fallow-ignore-next-line unused-export */\n}\n.settingIcon .img,\n.settingIcon .svg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.settingsText {\n  min-width: 150px;\n  max-width: 500px;\n  flex-grow: 1;\n  flex-shrink: 1;\n  text-align: left;\n  padding-right: 3em;\n}\n.settingsText .label {\n  font-size: 16.2px;\n  font-weight: 700;\n  font-style: bold;\n}\n.settingsText .description {\n  font-size: 12.6px;\n  font-weight: 400;\n  color: var(--settings-modal-text-color);\n}\n.settingValue {\n  color: white;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  /* Prevent value/toggle from collapsing */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingItem": `NT5C42JZOYzKUzH3LgbA`,
	"settingIcon": `uSJATcwjNIzOaL59V_qA`,
	"img": `hMMTbANT6O4ETtME3DEA`,
	"svg": `mJ8VUokWkyUNjufMhUY0`,
	"settingsText": `cTjuyFKj6gJz1zAqqSyq`,
	"label": `OMzJXYDHXoiIQEcgmAZw`,
	"description": `Qh40jG59iSQ_gzempUhe`,
	"settingValue": `X4Mj6K5UeIHvXGMcQ0Sx`
};
export default ___CSS_LOADER_EXPORT___;
